import React from 'react'
import SupervisorLayout from '../components/SupervisorLayout'
import NavDashboard from '../components/NavDashboard'

const SDashboard = () => {
  return (
    <div>
        <SupervisorLayout/>
        <NavDashboard/>
    </div>
  )
}

export default SDashboard